import React, { useState, useEffect } from 'react';
import { Typography, Form, Input, Upload, Button, InputNumber, Row, Col, Tooltip } from 'antd';
import { createUseStyles } from 'react-jss'

import { UploadOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';

const { Title } = Typography;

const useStyles = createUseStyles({
    transfer: {
        '&.ant-transfer': {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        '&.ant-transfer .ant-transfer-list ': {
            flex: "auto",
            height: "500px",
        }
    }
})

function UploadFile({ onChange, auth, label }) {
    const [file, setFile] = React.useState();

    const conf = (auth, setFile) => {
        return {
            multiple: false,
            // listType: "picture",
            maxCount: 1,
            // showUploadList: false,
            accept: ".docx",
            onRemove: () => {
                setFile(undefined)
            },
            beforeUpload: (f) => {
                setFile(f)
                return false;
            }
        }
    };

    useEffect(() => {
        onChange(file)
    }, [file])

    return (
        <Upload {...conf(auth, setFile)}>
            {(!file) &&
                <Button type='text' icon={<UploadOutlined />}>{label}</Button>
            }
        </Upload>
    )
}

export default function SeriiDiplomas(props) {
    const { auth, object } = props;

    const [loading, setLoading] = useState(false);

    const file = Form.useWatch('file', props.form);

    return (
        <>
            <Form
                form={props.form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    seriyaID: object.ID,
                    fileStart: 1,
                    fileEnd: 3,
                }}
            >
                <Form.Item
                    preserve={"true"}
                    hidden={true}
                    name={"seriyaID"}
                    label={"Серия"}
                >
                    <Input disabled />
                </Form.Item>
                <div /*className='bg bg-grey'*/ style={{ marginBottom: "10px", textAlign: "left", padding: "5px" }}>
                    <div style={{ fontWeight: "600", paddingLeft: "5px" }}>
                        Шаблон
                    </div>
                    <Form.Item name="file" style={{ margin: "0px" }}>
                        <UploadFile auth={auth} label="Загрузить файл шаблона" />
                    </Form.Item>
                    {(!!file) && <div className='parameters'>
                        <div style={{ display: "flex", justifyContent: "space-between", padding: "2px 0" }}>
                            <div className='parameters-title' style={{ flex: 1, maxWidth: "210px" }}>Начальное и конечное место:</div>
                            <div style={{ display: "flex" }}>
                                <Form.Item style={{ flex: 1, width: "100%", margin: "0" }} name={"fileStart"}>
                                    <InputNumber prefix={
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12"><path d="M23.73,11.356l-5.154-5.087c-.581-.574-1.575-.167-1.575,.644v3.587H3V4.5c0-.829-.671-1.5-1.5-1.5s-1.5,.671-1.5,1.5v15c0,.829,.671,1.5,1.5,1.5s1.5-.671,1.5-1.5v-6h14v3.587c0,.811,.994,1.218,1.575,.644l5.154-5.087c.36-.356,.36-.932,0-1.288Z" /></svg>
                                    } min={1} bordered={false} size="small" />
                                </Form.Item>
                                <Form.Item style={{ flex: 1, width: "100%", margin: "0" }} name={"fileEnd"}>
                                    <InputNumber prefix={
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12"><path d="M22.5,3c-.828,0-1.5,.671-1.5,1.5v7.247c-.042-.143-.12-.278-.234-.391l-5.191-5.087c-.581-.574-1.575-.167-1.575,.644v3.587H1.5c-.829,0-1.5,.671-1.5,1.5s.671,1.5,1.5,1.5H14v3.587c0,.811,.994,1.218,1.575,.644l5.191-5.087c.114-.113,.192-.248,.234-.391v7.247c0,.829,.672,1.5,1.5,1.5s1.5-.671,1.5-1.5V4.5c0-.829-.672-1.5-1.5-1.5Z" /></svg>
                                    } min={1} bordered={false} size="small" />
                                </Form.Item>
                            </div>
                        </div>
                        <div className='parameters-description'></div>
                    </div>}
                </div>
            </Form>
        </>
    );
}
